package amazon.lastmile.inject

import app.nestbridge.feature.careteam.presentation.CreateCareTeamPresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = CreateCareTeamPresenterFactory::class)
public interface AppNestbridgeFeatureCareteamPresentationCreateCareTeamPresenterFactory {
  @Provides
  @IntoSet
  public fun provideCreateCareTeamPresenterFactoryFactoryMultibinding(createCareTeamPresenterFactory: CreateCareTeamPresenterFactory): Presenter.Factory = createCareTeamPresenterFactory
}
